import React from 'react';
import { Button, Col, Row } from 'components';
import { ArrowLeftIcon } from 'components/common/icons';
import styles from './styles.module.scss';
import { Details } from './details';
import { TabNav } from './tabNav';

export const Role = React.memo(() => {
  return (
    <Row className={styles.country}>
      <Col>
        <Button title={'Click to go back'} onClick={() => history.back()} type={'link'} icon={<ArrowLeftIcon />} />
      </Col>
      <Col className={styles.main_section}>
        <Row>
          <Col flex={'296px'}>
            <Row className={styles.left_banner}>
              <Col>
                <Details />
              </Col>
            </Row>
          </Col>
          <Col flex={'1'} className={styles.right_section}>
            <TabNav />
          </Col>
        </Row>
      </Col>
    </Row>
  );
});
